(function () {
  'use strict';
  const W = window;
  const D = W.document;
  const KEY = 'duvanze_customizer_v1';
  const configNode = D && D.getElementById('duvanze-cart-flow-config');
  const config = configNode ? JSON.parse(configNode.textContent) : (W.DuvanzeCartConfig || {});
  const words = config.messages || {};
  const t = key => words[key] || key;
  const measurements = ['Shoulder Width', 'Bust', 'Upper Bust', 'Under Bust', 'Neck', 'Hip', 'Abdomen', 'Sleeve Width', 'Sleeve Length', 'Armhole', 'Bust Depth', 'Front Chest Width', 'Back Chest Width', 'Front Waist Length', 'Back Waist Length'];
  const shapes = ['Shoulder Shape', 'Bust Shape', 'Hip Shape', 'Abdomen Shape'];
  const bodyKeys = new Set(['Height', 'Weight', 'Age', 'Body Sleeve Length', ...measurements.filter(k => k !== 'Sleeve Length'), ...shapes]);
  const route = path => (W.Shopify?.routes?.root || '/').replace(/\/?$/, '/') + path;
  const read = () => { try { return JSON.parse(W.sessionStorage.getItem(KEY) || '{}'); } catch (_) { return {}; } };
  const write = value => W.sessionStorage.setItem(KEY, JSON.stringify(value));
  const uid = () => W.crypto.randomUUID();
  const canonical = value => JSON.stringify(Object.entries(value || {}).sort(([a], [b]) => a.localeCompare(b)));
  const isCustom = item => !!item.properties?._duvanze_item_id || (config.productIds || []).map(String).includes(String(item.product_id));
  async function request(path, options) {
    const response = await W.fetch(route(path), { credentials: 'same-origin', cache: 'no-store', ...options });
    let result;
    try { result = await response.json(); } catch (_) { throw new Error(t('network_error')); }
    if (!response.ok) throw new Error(result.description || result.message || t('network_error'));
    return result;
  }
  const cart = () => request('cart.js');
  const change = (item, properties) => request('cart/change.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: item.key, quantity: item.quantity, properties })
  });
  function bodyFromProperties(properties) {
    const p = properties || {};
    if (p._duvanze_body) { try { return JSON.parse(p._duvanze_body); } catch (_) {} }
    const profile = {};
    let match = String(p.Height || '').match(/^([\d.]+)\s*cm$/);
    if (match) Object.assign(profile, { unit: 'metric', heightCm: match[1] });
    match = String(p.Height || '').match(/^([\d.]+)\s*ft\s*([\d.]+)\s*in$/);
    if (match) Object.assign(profile, { unit: 'us', heightFt: match[1], heightIn: match[2] });
    match = String(p.Weight || '').match(/^([\d.]+)\s*(kg|lb)$/);
    if (match) Object.assign(profile, { weight: match[1], weightUnit: match[2] });
    profile.age = String(p.Age || '').replace(/\s*years?$/, '');
    const measured = {};
    measurements.forEach(key => {
      const propertyKey = key === 'Sleeve Length' ? 'Body Sleeve Length' : key;
      const match = String(p[propertyKey] || '').match(/^([\d.]+)\s*(cm|in)$/);
      if (match) measured[key] = { value: match[1], unit: match[2] === 'cm' ? 'metric' : 'us' };
    });
    return { profile, measurements: measured, bodyShapeDetails: Object.fromEntries(shapes.filter(k => p[k]).map(k => [k, p[k]])) };
  }
  function validBody(data) {
    const p = data.profile || {};
    const height = p.unit === 'metric' ? Number(p.heightCm) : Number(p.heightFt) * 12 + Number(p.heightIn);
    return ['us', 'metric'].includes(p.unit) && Number.isFinite(height) && height > 0 &&
      Number(p.weight) > 0 && Number(p.age) > 0 && measurements.every(key => {
        const m = data.measurements?.[key];
        return m && Number.isFinite(Number(m.value)) && Number(m.value) > 0 && ['us', 'metric'].includes(m.unit);
      }) && shapes.every(key => !!data.bodyShapeDetails?.[key]);
  }
  function bodyProperties(data) {
    if (!validBody(data)) throw new Error(t('body_required'));
    const p = data.profile;
    const props = {
      Height: p.unit === 'metric' ? p.heightCm + ' cm' : p.heightFt + ' ft ' + p.heightIn + ' in',
      Weight: p.weight + (p.unit === 'metric' ? ' kg' : ' lb'), Age: p.age + ' years'
    };
    measurements.forEach(key => {
      const m = data.measurements[key];
      props[key === 'Sleeve Length' ? 'Body Sleeve Length' : key] = m.value + (m.unit === 'metric' ? ' cm' : ' in');
    });
    shapes.forEach(key => { props[key] = data.bodyShapeDetails[key]; });
    props._duvanze_body = JSON.stringify({ profile: p, measurements: data.measurements, bodyShapeDetails: data.bodyShapeDetails });
    return props;
  }
  function designProperties(properties) {
    return Object.fromEntries(Object.entries(properties || {}).filter(([key]) => !bodyKeys.has(key) && !key.startsWith('_duvanze_')));
  }
  function hasPreview(properties, files = []) {
    const value = String(properties?.Preview || '').trim();
    return /^(https:\/\/|\/\/|\/uploads\/)/i.test(value) || files.some(entry => entry.key === 'Preview' && entry.file?.size > 0 && /^image\//i.test(entry.file.type || ''));
  }
  function designComplete(item) {
    const p = item.properties || {};
    if (p._duvanze_design_complete !== undefined) return p._duvanze_design_complete === 'true';
    return Object.keys(designProperties(p)).some(key => !key.startsWith('_') && key !== 'Preview');
  }
  function pending(item, currentCart) {
    const replaces = item.properties?._duvanze_replaces;
    if (replaces && currentCart.items.some(other => other.properties?._duvanze_item_id === replaces)) return true;
    return isCustom(item) && (!designComplete(item) || !hasPreview(item.properties) || !validBody(bodyFromProperties(item.properties)));
  }
  function findItem(currentCart, edit) {
    const matches = currentCart.items.filter(item => item.properties?._duvanze_item_id === edit.uid);
    if (matches.length !== 1) throw new Error(t('item_changed'));
    const item = matches[0];
    if (String(item.variant_id) !== String(edit.variantId) || canonical(item.properties) !== canonical(edit.properties)) throw new Error(t('item_changed'));
    return item;
  }
  async function beginEdit(key, mode) {
    let currentCart = await cart();
    let item = currentCart.items.find(i => i.key === key);
    if (!item || !isCustom(item)) throw new Error(t('item_changed'));
    if (!item.properties?._duvanze_item_id) {
      const id = uid();
      currentCart = await change(item, { ...item.properties, _duvanze_item_id: id });
      item = currentCart.items.find(i => i.properties?._duvanze_item_id === id);
      if (!item) throw new Error(t('item_changed'));
    }
    const body = bodyFromProperties(item.properties);
    const properties = designProperties(item.properties);
    const draft = {
      schemaVersion: 2, productId: String(item.product_id), productHandle: item.handle,
      productTitle: item.product_title, productImage: item.image, variantId: String(item.variant_id),
      design: Object.fromEntries(Object.entries(properties).filter(([key]) => !key.startsWith('_') && key !== 'Preview')),
      properties, ...body,
      cartEdit: { mode, uid: item.properties._duvanze_item_id, variantId: String(item.variant_id), properties: { ...item.properties } }
    };
    write(draft);
    return mode === 'body' ? route('pages/body-profile') : route('products/' + encodeURIComponent(item.handle)) + '?variant=' + item.variant_id + '&duvanze_edit=1';
  }
  function metadata(draft, id, complete) {
    const result = { _duvanze_item_id: id, _duvanze_design_complete: String(complete), _duvanze_version: '3' };
    if (draft.controls?.length) result._duvanze_controls = JSON.stringify(draft.controls);
    return result;
  }
  async function add(draft, files, includeBody) {
    if (Object.keys(draft.design || {}).length && !hasPreview(draft.properties, files || [])) throw new Error(t('preview_required'));
    const id = draft.addUid || uid();
    draft.addUid = id;
    draft.addMode = includeBody;
    write(draft);
    const existing = (await cart()).items.find(item => item.properties?._duvanze_item_id === id);
    if (existing) return existing;
    const props = { ...designProperties(draft.properties), ...metadata(draft, id, !!Object.keys(draft.design || {}).length) };
    if (includeBody) Object.assign(props, bodyProperties(draft));
    return addLine(draft.variantId, 1, props, files || []);
  }
  async function addLine(variantId, quantity, props, files) {
    const body = new FormData();
    body.append('id', variantId); body.append('quantity', String(quantity));
    Object.entries(props).forEach(([key, value]) => { if (value != null) body.append('properties[' + key + ']', String(value)); });
    files.forEach(({ key, file }) => body.set('properties[' + key + ']', file, file.name || 'live-preview.png'));
    return request('cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
  }
  async function saveBody(draft) {
    const currentCart = await cart();
    const item = findItem(currentCart, draft.cartEdit);
    const props = { ...item.properties };
    bodyKeys.forEach(key => delete props[key]);
    Object.assign(props, bodyProperties(draft));
    return change(item, props);
  }
  async function saveDesign(draft, files) {
    if (!hasPreview(draft.properties, files || [])) throw new Error(t('preview_required'));
    let currentCart = await cart();
    const item = findItem(currentCart, draft.cartEdit);
    if (String(draft.variantId) !== String(item.variant_id)) throw new Error(t('item_changed'));
    const body = validBody(draft) ? bodyProperties(draft) : Object.fromEntries(Object.entries(item.properties || {}).filter(([key]) => bodyKeys.has(key) || key === '_duvanze_body'));
    const props = { ...designProperties(draft.properties), ...body, ...metadata(draft, draft.cartEdit.uid, true) };
    if (!files.length) return change(item, props);
    const replacementId = draft.replacementUid || uid();
    draft.replacementUid = replacementId; write(draft);
    props._duvanze_item_id = replacementId;
    props._duvanze_replaces = draft.cartEdit.uid;
    let replacement = currentCart.items.find(i => i.properties?._duvanze_item_id === replacementId);
    if (!replacement) await addLine(draft.variantId, item.quantity, props, files);
    currentCart = await cart();
    replacement = currentCart.items.find(i => i.properties?._duvanze_item_id === replacementId);
    if (!replacement || !hasPreview(replacement.properties)) throw new Error(t('preview_required'));
    try {
      const original = findItem(currentCart, draft.cartEdit);
      await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: original.key, quantity: 0 }) });
    } catch (error) {
      const latest = await cart();
      const original = latest.items.find(i => i.properties?._duvanze_item_id === draft.cartEdit.uid);
      if (!original && latest.items.some(i => i.properties?._duvanze_item_id === replacementId)) return latest;
      const staged = latest.items.find(i => i.properties?._duvanze_item_id === replacementId);
      if (staged) {
        try { await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: staged.key, quantity: 0 }) }); } catch (_) {}
      }
      throw error;
    }
    return cart();
  }
  function finish() {
    const draft = read();
    delete draft.cartEdit; delete draft.addUid; delete draft.addMode; delete draft.replacementUid;
    write(draft);
    W.location.href = route('cart');
  }
  function renderActions(currentCart) {
    D.querySelectorAll('[data-duvanze-cart-actions]').forEach(node => {
      const item = currentCart.items.find(i => i.key === node.dataset.key);
      if (!item || !isCustom(item)) return;
      node.replaceChildren();
      const state = D.createElement('p');
      state.className = 'dv-cart-status';
      state.textContent = !designComplete(item) ? t('design_pending') : !hasPreview(item.properties) ? t('preview_missing') : validBody(bodyFromProperties(item.properties)) ? t('complete') : t('body_pending');
      node.appendChild(state);
      const actions = designComplete(item) ? [['body', validBody(bodyFromProperties(item.properties)) ? 'edit_body' : 'enter_body'], ['design', 'redesign']] : [['design', 'start_design']];
      actions.forEach(([mode, label]) => {
        const button = D.createElement('button');
        button.type = 'button'; button.className = 'dv-cart-action'; button.textContent = t(label);
        button.addEventListener('click', async () => {
          button.disabled = true;
          try { W.location.href = await beginEdit(item.key, mode); }
          catch (error) { W.alert(error.message); button.disabled = false; }
        });
        node.appendChild(button);
      });
    });
    const incomplete = currentCart.items.some(item => pending(item, currentCart));
    D.querySelectorAll('[data-duvanze-checkout-warning]').forEach(node => { node.hidden = !incomplete; });
    D.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(node => {
      if (incomplete) { node.dataset.duvanzeBlocked = 'true'; node.hidden = true; }
      else if (node.dataset.duvanzeBlocked) { node.hidden = false; delete node.dataset.duvanzeBlocked; }
    });
  }
  const api = { KEY, t, route, read, write, uid, cart, request, validBody, bodyProperties, bodyFromProperties, designProperties, designComplete, hasPreview, isCustom, pending, findItem, beginEdit, add, saveBody, saveDesign, finish, measurements };
  W.DuvanzeCartFlow = api;
  if (!D) return;
  let refreshing = false;
  async function refresh() {
    if (refreshing || !D.querySelector('[data-duvanze-cart-actions]')) return;
    refreshing = true;
    try { renderActions(await cart()); } catch (_) {} finally { refreshing = false; }
  }
  let timer;
  new MutationObserver(records => {
    if (records.every(r => r.target.closest?.('[data-duvanze-cart-actions]'))) return;
    clearTimeout(timer); timer = setTimeout(refresh, 150);
  }).observe(D.body, { childList: true, subtree: true });
  refresh();
  let checking = false;
  async function guard(event) {
    const submit = event.type === 'submit' ? event.submitter : event.target.closest?.('[name="checkout"], a[href*="/checkout"]');
    if (!submit || submit.dataset.duvanzeAllowed === 'true') return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    try {
      const currentCart = await cart();
      if (currentCart.items.some(item => pending(item, currentCart))) {
        renderActions(currentCart); W.alert(t('checkout_required'));
        D.querySelector('[data-duvanze-cart-actions]')?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } else {
        submit.dataset.duvanzeAllowed = 'true';
        submit.click();
        delete submit.dataset.duvanzeAllowed;
      }
    } catch (error) { W.alert(error.message); }
    finally { checking = false; }
  }
  D.addEventListener('click', guard, true);
  D.addEventListener('submit', guard, true);
})();

